export const isImageFileName = (fileName: string): boolean =>
  /\.(jpg|jpeg|png|gif|webp|svg|bmp|tiff|avif|heic|heif)$/i.test(fileName);
